import {createSelector} from '@reduxjs/toolkit'

export const companyPeopleListSelector = createSelector(
    [state => state.primaryAgencyApplication.application?.businessLicenceData],
    (applicationData) => {
        let peopleList = []

        if(applicationData?.companyRjscDetails?.businessData?.peopleList
            && Array.isArray(applicationData.companyRjscDetails.businessData.peopleList)) { 
                applicationData.companyRjscDetails.businessData.peopleList.forEach((people) => {
                    peopleList.push(
                        Object.assign({}, people)
                    )
                })
        }
        
        return peopleList
    }
)
